import { useEffect } from 'react';

interface PageMetaOptions {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  noindex?: boolean;
}

const usePageMeta = ({ title, description, keywords, canonical, noindex }: PageMetaOptions) => {
  useEffect(() => {
    // Title
    document.title = title;

    // Robots (noindex für rechtliche Seiten)
    let robotsEl = document.querySelector('meta[name="robots"]');
    if (!robotsEl) {
      robotsEl = document.createElement('meta');
      (robotsEl as HTMLMetaElement).name = 'robots';
      document.head.appendChild(robotsEl);
    }
    (robotsEl as HTMLMetaElement).content = noindex ? 'noindex, nofollow' : 'index, follow';

    // Description
    let descEl = document.querySelector('meta[name="description"]');
    if (!descEl) {
      descEl = document.createElement('meta');
      (descEl as HTMLMetaElement).name = 'description';
      document.head.appendChild(descEl);
    }
    (descEl as HTMLMetaElement).content = description;

    // Keywords
    if (keywords) {
      let kwEl = document.querySelector('meta[name="keywords"]');
      if (!kwEl) {
        kwEl = document.createElement('meta');
        (kwEl as HTMLMetaElement).name = 'keywords';
        document.head.appendChild(kwEl);
      }
      (kwEl as HTMLMetaElement).content = keywords;
    }

    // Canonical
    if (canonical) {
      let canonEl = document.querySelector('link[rel="canonical"]');
      if (!canonEl) {
        canonEl = document.createElement('link');
        (canonEl as HTMLLinkElement).rel = 'canonical';
        document.head.appendChild(canonEl);
      }
      (canonEl as HTMLLinkElement).href = canonical;
    }

    // OG Tags
    const setOg = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        (el as HTMLMetaElement).setAttribute('property', property);
        document.head.appendChild(el);
      }
      (el as HTMLMetaElement).content = content;
    };
    setOg('og:title', title);
    setOg('og:description', description);
    if (canonical) setOg('og:url', canonical);
  }, [title, description, keywords, canonical]);
};

export default usePageMeta;
